import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { App, Modal } from 'antd'

import { buildOnboardingCallCalendlyEmbedUrl, OnboardingCallCtaPlacement } from './onboarding-call-cta-url'
import { useCalendlyBookingPostMessageListener } from './use-calendly-booking-post-message-listener'
import './onboarding-call-cta.less'

interface OnboardingCallCalendlyEmbedModalProps {
  open: boolean
  onClose: () => void
  placement: OnboardingCallCtaPlacement
  userId: string
  companyId: string
}

export const OnboardingCallCalendlyEmbedModal: React.FC<OnboardingCallCalendlyEmbedModalProps> = (props) => (
  <Modal
    open={props.open}
    onCancel={props.onClose}
    footer={null}
    destroyOnClose
    zIndex={12050}
    title={null}
    className="onboarding-call-cta-calendly-modal"
    centered
    width="min(1200px, calc(100vw - 48px))"
  >
    {props.open ? <OnboardingCallCalendlyEmbedModalBody {...props} /> : null}
  </Modal>
)

function OnboardingCallCalendlyEmbedModalBody({ onClose, placement, userId, companyId }: OnboardingCallCalendlyEmbedModalProps) {
  const { formatMessage } = useIntl()
  const { notification } = App.useApp()
  const iframeSrc = useMemo(() => buildOnboardingCallCalendlyEmbedUrl(placement), [placement])

  useCalendlyBookingPostMessageListener({
    open: true,
    userId,
    companyId,
    onClose,
    formatMessage,
    notification,
  })

  return (
    <div className="onboarding-call-cta-calendly-embed">
      {iframeSrc ? <iframe title="Calendly scheduling" src={iframeSrc} className="onboarding-call-cta-calendly-embed__iframe" /> : null}
    </div>
  )
}
